  (function() {
    // Máscara CEP 00000-000
    // Selet 20/09: formatação idempotente (pode rodar várias vezes sobre o mesmo valor sem alterá-lo)
    function seletFormatCep(value) {
      let v = String(value || '').replace(/\D/g, '');
      if (v.length > 8) v = v.substring(0, 8);
      if (v.length > 5) {
        v = v.replace(/^(\d{5})(\d{0,3})/, '$1-$2');
      }
      return v;
    }
    function applyCepMask(input) {
      if (!input) return;
      if (input.__seletMasked) return; // Selet 20/09: idempotente — não duplica listeners
      input.__seletMasked = true;
      input.addEventListener('input', function(e) {
        let v = seletFormatCep(e.target.value);
        if (e.target.value !== v) e.target.value = v;
        // Selet 19/09: calcula sozinho ao completar os 8 dígitos (sem precisar clicar em CALCULAR)
        if (v.replace(/\D/g, '').length === 8) {
          clearTimeout(input.__seletAuto);
          input.__seletAuto = setTimeout(function () { calculateSeletShipping(input.id.replace('selet-cep-input-', '')); }, 250);
        }
      });
      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          const scope = input.id.replace('selet-cep-input-', '');
          calculateSeletShipping(scope);
        }
      });
    }

    // Inicialização dos inputs — roda no carregamento E a cada re-renderização do drawer/página
    // (Selet 18/09: o tema re-renderiza o drawer a cada item adicionado e o CEP salvo voltava vazio).
    function seletInitCepInputs() {
      // Selet 20/09: listener delegado (registrado uma vez) — mascara um input recém-injetado no drawer
      // antes mesmo do re-init do MutationObserver (150 ms).
      if (!window.__seletCepDelegated) {
        window.__seletCepDelegated = true;
        document.addEventListener('input', function (e) {
          const t = e.target;
          if (!t || !t.classList || !t.classList.contains('selet-cep-input')) return;
          const v = seletFormatCep(t.value);
          if (t.value !== v) t.value = v;
        }, true);
      }
      let savedCep = '';
      try { savedCep = localStorage.getItem('selet_customer_cep') || ''; } catch (e) {}
      ['cart', 'product', 'cartpage'].forEach(scope => {
        const input = document.getElementById('selet-cep-input-' + scope);
        if (!input || input.dataset.seletInit === '1') return;
        input.dataset.seletInit = '1';
        applyCepMask(input);
        // esconde o bloco se o carrinho já tem frete grátis (o drawer re-renderizado voltava a mostrá-lo)
        getSeletCartSubtotal().then(seletToggleCalc);
        if (savedCep && !input.value) {
          input.value = savedCep;
          // Se houver CEP salvo, faz o cálculo automaticamente
          setTimeout(() => calculateSeletShipping(scope), 200);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', seletInitCepInputs);
    if (window.MutationObserver && !window.__seletCepObserver) {
      let t;
      window.__seletCepObserver = new MutationObserver(function () { clearTimeout(t); t = setTimeout(seletInitCepInputs, 150); });
      window.__seletCepObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
    seletInitCepInputs();

    // Função de cálculo de frete
    window.calculateSeletShipping = function(scope) {
      const input = document.getElementById('selet-cep-input-' + scope);
      const resultsContainer = document.getElementById('selet-shipping-results-' + scope);
      const btn = document.getElementById('selet-cep-btn-' + scope);

      if (!input || !resultsContainer) return;

      const rawCep = input.value.replace(/\D/g, '');
      if (rawCep.length !== 8) {
        resultsContainer.style.display = 'block';
        resultsContainer.innerHTML = '<div class="selet-shipping-error">Informe um CEP válido com 8 dígitos.</div>';
        return;
      }

      // Salva CEP no localStorage
      localStorage.setItem('selet_customer_cep', input.value);

      // Loading state
      if (btn) {
        btn.querySelector('.selet-btn-text').style.display = 'none';
        btn.querySelector('.selet-btn-spinner').style.display = 'inline-block';
      }

      // Consulta de CEP com limite de 4 s e segundo provedor (Selet 18/09: o ViaCEP oscila em horário de pico)
      function fetchCep(url, map) {
        const ctrl = ('AbortController' in window) ? new AbortController() : null;
        const timer = setTimeout(function () { ctrl && ctrl.abort(); }, 4000);
        return fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function (d) { clearTimeout(timer); return map(d); })
          .catch(function (e) { clearTimeout(timer); throw e; });
      }
      const viaCep = function () { return fetchCep('https://viacep.com.br/ws/' + rawCep + '/json/', function (d) { if (d.erro) return { erro: true }; return d; }); };
      const brasilApi = function () { return fetchCep('https://brasilapi.com.br/api/cep/v1/' + rawCep, function (d) { if (!d || !d.state) return { erro: true }; return { cep: d.cep, uf: d.state, localidade: d.city, bairro: d.neighborhood || '', logradouro: d.street || '' }; }); };
      viaCep().catch(function () { return brasilApi(); })
        .then(data => {
          if (btn) {
            btn.querySelector('.selet-btn-text').style.display = 'inline-block';
            btn.querySelector('.selet-btn-spinner').style.display = 'none';
          }

          if (data.erro) {
            resultsContainer.style.display = 'block';
            resultsContainer.innerHTML = '<div class="selet-shipping-error">CEP não encontrado. Verifique o número digitado.</div>';
            return;
          }

          window.__seletLastAddress = data;
          // Selet 19/09: guarda o endereço do CEP para o carrinho já mandar rua/bairro/cidade/UF ao checkout
          try { localStorage.setItem('selet_customer_endereco', JSON.stringify({ cep: rawCep, logradouro: data.logradouro || '', bairro: data.bairro || '', localidade: data.localidade || '', uf: data.uf || '' })); } catch (e) {}
          getSeletCartSubtotal().then(function(subtotal) {
            // Selet 19/09: cotação real (as mesmas opções do checkout — Melhor Envio via Gadol); se falhar, cai na tabela estimada
            return fetchSeletRates(rawCep, data.uf || '').then(function (rates) {
              renderShippingOptions(resultsContainer, data, subtotal, rates);
            });
          });
        })
        .catch(err => {
          if (btn) {
            btn.querySelector('.selet-btn-text').style.display = 'inline-block';
            btn.querySelector('.selet-btn-spinner').style.display = 'none';
          }
          resultsContainer.style.display = 'block';
          resultsContainer.innerHTML = '<div class="selet-shipping-error">Não foi possível calcular o frete no momento. Tente novamente.</div>';
        });
    };

    // Cotações reais do carrinho (Shopify /cart/shipping_rates.json → mesmas transportadoras/preços do checkout).
    // A Shopify pode responder 202 enquanto calcula; tenta de novo por até ~8 s. Devolve null se não houver itens ou der erro.
    function fetchSeletRates(rawCep, uf) {
      var url = '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + rawCep.slice(0, 5) + '-' + rawCep.slice(5)
        + '&shipping_address%5Bcountry%5D=BR&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf || '');
      var tries = 0;
      function attempt() {
        tries++;
        return fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
          if (r.status === 202 && tries < 7) { return new Promise(function (res) { setTimeout(res, 1200); }).then(attempt); }
          if (!r.ok) return null;
          return r.json().then(function (j) {
            var rates = (j && j.shipping_rates) || [];
            if (!rates.length) return null;
            return rates.map(function (x) {
              return { name: String(x.presentment_name || x.name || ''), cents: Math.round(parseFloat(x.price || '0') * 100), days: Array.isArray(x.delivery_days) ? x.delivery_days : null };
            });
          });
        }).catch(function () { return null; });
      }
      return attempt();
    }

    // Subtotal do carrinho em centavos (mesma fonte da barra de frete grátis)
    function getSeletCartSubtotal() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(c) { return c.items_subtotal_price || 0; })
        .catch(function() { return 0; });
    }

    // Quando o carrinho muda (evento disparado pela barra de frete grátis da PDP / PUB_SUB do tema), recalcula
    function seletShippingRefresh() {
      if (!window.__seletLastAddress) return;
      ['cart', 'product', 'cartpage'].forEach(function(scope) {
        const c = document.getElementById('selet-shipping-results-' + scope);
        if (c && c.style.display === 'block') {
          var a = window.__seletLastAddress;
          getSeletCartSubtotal().then(function(subtotal) {
            return fetchSeletRates(String(a.cep || '').replace(/\D/g, '') || (localStorage.getItem('selet_customer_cep') || '').replace(/\D/g, ''), a.uf || '')
              .then(function (rates) { renderShippingOptions(c, a, subtotal, rates); });
          });
        }
      });
    }
    document.addEventListener('selet:cart', seletShippingRefresh);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function() { setTimeout(seletShippingRefresh, 800); });
    }

    function brlFromCents(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    // Esconde o bloco inteiro quando o carrinho já garante frete grátis (a barra verde assume a mensagem)
    function seletToggleCalc(subtotalCents) {
      document.querySelectorAll('.selet-shipping-calc').forEach(function(calc) {
        const minCents = Math.round(parseFloat(calc.dataset.seletFsMin || '0') * 100);
        const isFree = minCents > 0 && (subtotalCents || 0) >= minCents;
        // Selet 19/09: não esconde mais com frete grátis — sem o CEP salvo o checkout não recebia o endereço
        calc.style.display = '';
      });
    }
    document.addEventListener('DOMContentLoaded', function() { getSeletCartSubtotal().then(seletToggleCalc); });
    document.addEventListener('selet:cart', function(e) { if (e.detail) seletToggleCalc(e.detail.items_subtotal_price || 0); });

    function renderShippingOptions(container, addressData, subtotalCents, rates) {
      const uf = addressData.uf || 'SP';
      const localidade = addressData.localidade || '';
      const calc = container.closest('.selet-shipping-calc');
      const minCents = Math.round(parseFloat((calc && calc.dataset.seletFsMin) || '0') * 100);
      const isFree = minCents > 0 && (subtotalCents || 0) >= minCents;
      seletToggleCalc(subtotalCents);

      // ---- Cotação real (mesmos valores do checkout) ----
      if (rates && rates.length) {
        var freeRate = rates.filter(function (r) { return r.cents === 0; })[0];
        var paid = rates.filter(function (r) { return r.cents > 0; }).sort(function (a, b) { return a.cents - b.cents; }).slice(0, 4);
        var cheapest = paid[0] ? paid[0].cents : 0;
        window.__seletPrazo = { localidade: localidade, uf: uf, pacDays: paid[0] && paid[0].days && paid[0].days[1] != null ? ((paid[0].days[0] === 0 || paid[0].days[0] == null) ? 'até ' : paid[0].days[0] + ' a ') + paid[0].days[1] + ' dias úteis' : '', pacPrice: brlFromCents(cheapest), pacCents: freeRate ? 0 : cheapest, real: true };
        try { localStorage.setItem('selet_customer_prazo', JSON.stringify(window.__seletPrazo)); } catch (e) {}
        document.dispatchEvent(new CustomEvent('selet:prazo', { detail: window.__seletPrazo }));
        var rows = '';
        var list = freeRate ? [freeRate].concat(paid) : paid;
        list.forEach(function (r) {
          var nm = r.name.replace(/\s*\(Melhor Envio\)\s*/i, '').replace(/^Correios\s+/i, 'Correios ');
          // Selet 19/09: a opção "Frete grátis" vem sem prazo da Shopify (aparecia "undefined dias úteis"); usa o prazo do envio econômico.
          var days = (r.days && r.days[1] != null) ? r.days : ((r.cents === 0 && paid[0] && paid[0].days && paid[0].days[1] != null) ? paid[0].days : null);
          var prazo = days ? (days[0] === days[1] ? days[0] + (days[0] === 1 ? ' dia útil' : ' dias úteis') : (days[0] === 0 || days[0] == null ? 'até ' + days[1] + ' dias úteis' : days[0] + ' a ' + days[1] + ' dias úteis')) : '';
          rows += '<div class="selet-shipping-option"><div class="selet-shipping-method-info"><span class="selet-shipping-method-name">' + nm + '</span>'
            + (prazo ? '<span class="selet-shipping-method-time">Prazo: ' + prazo + '</span>' : '') + '</div>'
            + '<span class="selet-shipping-method-price">' + (r.cents === 0 ? '<span class="selet-shipping-free-badge">GRÁTIS</span>' : brlFromCents(r.cents)) + '</span></div>';
        });
        container.style.display = 'block';
        container.innerHTML = '<div class="selet-shipping-city">📍 Entrega para <strong>' + localidade + ' - ' + uf + '</strong>:</div>' + rows
          + (minCents > 0 ? (freeRate
            ? '<div class="selet-shipping-note"><strong>Frete grátis garantido</strong> — seu carrinho já passou de ' + brlFromCents(minCents) + '. As outras opções são mais rápidas, se preferir.</div>'
            : '<div class="selet-shipping-note"><strong>Frete grátis</strong> acima de ' + brlFromCents(minCents) + ' (itens do carrinho somam). Valores reais — os mesmos do checkout.</div>') : '');
        return;
      }
      // ---- Tabela estimada por região (usada só quando a cotação real não vier, ex.: carrinho vazio na página do produto) ----

      // Tabela de prazos e valores estimados por região
      let pacDays = '5 a 8 dias úteis';
      let sedexDays = '2 a 4 dias úteis';
      let pacPrice = 'R$ 18,90';
      let sedexPrice = 'R$ 28,50';

      if (uf === 'SP') {
        pacDays = '2 a 4 dias úteis';
        sedexDays = '1 a 2 dias úteis';
        pacPrice = 'R$ 14,90';
        sedexPrice = 'R$ 19,90';
      } else if (['RJ', 'MG', 'ES', 'PR', 'SC', 'RS'].includes(uf)) {
        pacDays = '4 a 6 dias úteis';
        sedexDays = '2 a 3 dias úteis';
        pacPrice = 'R$ 19,90';
        sedexPrice = 'R$ 29,90';
      } else if (['DF', 'GO', 'MT', 'MS', 'BA'].includes(uf)) {
        pacDays = '6 a 9 dias úteis';
        sedexDays = '3 a 5 dias úteis';
        pacPrice = 'R$ 24,90';
        sedexPrice = 'R$ 36,90';
      } else {
        pacDays = '8 a 14 dias úteis';
        sedexDays = '4 a 7 dias úteis';
        pacPrice = 'R$ 29,90';
        sedexPrice = 'R$ 44,90';
      }

      window.__seletPrazo = { localidade: localidade, uf: uf, pacDays: pacDays, pacPrice: pacPrice, pacCents: isFree ? 0 : Math.round(parseFloat(pacPrice.replace(/[^0-9,]/g, '').replace(',', '.')) * 100) };
      try { localStorage.setItem('selet_customer_prazo', JSON.stringify(window.__seletPrazo)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('selet:prazo', { detail: window.__seletPrazo }));

      container.style.display = 'block';
      container.innerHTML = `
        <div class="selet-shipping-city">
          📍 Entrega para <strong>${localidade} - ${uf}</strong>:
        </div>
        <div class="selet-shipping-option">
          <div class="selet-shipping-method-info">
            <span class="selet-shipping-method-name">Envio Padrão (PAC)</span>
            <span class="selet-shipping-method-time">Prazo: ${pacDays}</span>
          </div>
          <span class="selet-shipping-method-price">${isFree ? '<span class="selet-shipping-price-old">' + pacPrice + '</span><span class="selet-shipping-free-badge">GRÁTIS</span>' : pacPrice}</span>
        </div>
        <div class="selet-shipping-option">
          <div class="selet-shipping-method-info">
            <span class="selet-shipping-method-name">Envio Expresso (SEDEX)</span>
            <span class="selet-shipping-method-time">Prazo: ${sedexDays}</span>
          </div>
          <span class="selet-shipping-method-price">${sedexPrice}</span>
        </div>
        ${minCents > 0 ? (isFree
          ? '<div class="selet-shipping-note"><strong>Frete grátis garantido</strong> — seu carrinho já passou de ' + brlFromCents(minCents) + '. Valores acima são estimativas; o SEDEX é opcional.</div>'
          : '<div class="selet-shipping-note"><strong>Frete grátis</strong> acima de ' + brlFromCents(minCents) + ' (itens do carrinho somam). Valores estimados; o frete final aparece no checkout.</div>') : ''}
      `;
    }
  })();
